var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 570,
    height: 23,
    viewBox: "0 0 570 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C1.17157 10 0.5 10.6716 0.5 11.5C0.5 12.3284 1.17157 13 2 13V10ZM569.062 12.5607C569.647 11.9749 569.647 11.0251 569.062 10.4393L559.516 0.893398C558.93 0.307611 557.98 0.307611 557.394 0.893398C556.808 1.47919 556.808 2.42893 557.394 3.01472L565.88 11.5L557.394 19.9853C556.808 20.5711 556.808 21.5208 557.394 22.1066C557.98 22.6924 558.93 22.6924 559.516 22.1066L569.062 12.5607ZM2 13H568.001V10H2V13Z",
    fill: "#DD3826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHeader);
export default __webpack_public_path__ + "static/media/line-header.a1db3d1ef0566cd90dac34b0cb67aba4.svg";
export { ForwardRef as ReactComponent };